export const isUndefined = (record: any): any | string => {
  if (record === null || record === undefined || record === '') {
    return '-'
  }
  return record
}
